<template>
  <div id="print-report">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <div class="label-text mr-4" style="font-weight: 700; font-size: 18px;">안전보건 관련 예산</div>
        <div class="w-full flex flex-1 items-center">
          <div class="flex items-center">
            <p v-if="isPrint" class="print-input">{{ year }}</p>
            <search-nav-item-select v-else v-model="year" :list="getYearList" @change="loadListBoard" />
            <p class="ml-2 mr-2 text-center">년</p>
          </div>
          <div class="flex items-center">
            <p v-if="isPrint" class="print-input">{{ month }}</p>
            <search-nav-item-select v-else v-model="month" :list="getMonthList" @change="loadListBoard"/>
            <p class="ml-2 text-center">월</p>
          </div>
        </div>
      </div>
      <div v-if="!isPrint" class="ml-auto">
        <vs-col class="flex" vs-justify="flex-end">
          <vs-button v-if="fieldData[selectedFieldId]" class="mr-2" type="border" color="secondary" @click="()=> showExcelDownload = true">{{$t('button.Excel 다운로드')}}</vs-button>
          <vs-button class="mr-2" type="filled" color="secondary" @click.prevent="onClickPrint">인쇄</vs-button>
        </vs-col>
      </div>
    </div>

    <div style="white-space: pre-line;">
      ※ 사업장별로 작성된 예산을 부서별로 모아보는 페이지 입니다.
      　 부서 선택 시, 선택한 부서가 작성한 예산 정보와 하위 부서 및 담당 수급업체가 작성한 예산 정보까지 함께 조회됩니다.
    </div>

    <div class="mt-6 mb-8">
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>조회 부서</h5></vs-col>
      </vs-row>
      <vs-row>
        <div class="flex items-center mr-8">
          <div class="flex items-center">
            <span style="width: 114px;">부서 선택</span>
            <p v-if="isPrint" class="print-input">{{ companyList.find((c) => c.id === selectedCompanyId).com_name }}</p>
            <vs-select v-else autocomplete v-model="selectedCompanyId">
              <vs-select-item
                v-for="(item, index) in companyList"
                :key="index"
                :text="item.com_name"
                :value="item.id"
              />
            </vs-select>
          </div>
        </div>

        <div v-if="this.fieldList && this.fieldList.length > 0" class="flex flex-1 items-center">
          <div class="flex items-center">
            <span style="width: 114px;">사업장 선택</span>
            <p v-if="isPrint" class="print-input">{{ getSelectedFieldName }}</p>
            <vs-select v-else autocomplete v-model="selectedFieldId">
              <vs-select-item
                text="전체 사업장"
                value="0"
              />
              <vs-select-item
                v-for="(item, index) in fieldList"
                :key="index"
                :text="item.stdInfo.field_name"
                :value="item.stdInfo.field_id"
              />
            </vs-select>
          </div>
        </div>
      </vs-row>
    </div>

    <!-- 산업안전보건관리비 -->
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>안전·보건예산 항목</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table table-5" style="border-bottom:none;">
            <li class="header header-bg grid-row" style="grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr">
              <span>항목별</span>
              <span>예산</span>
              <span>당월 사용금액</span>
              <span>누계</span>
              <span>집행률</span>
            </li>

            <!-- 안전보건인건비 -->
            <li class="grid-row"
                v-for="item in fieldData[`${selectedFieldId}`] ? fieldData[`${selectedFieldId}`].inputB : form.inputB"
                :key="item.label" style="grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr">
              <span class="header-bg">{{ item.label }}</span>
              <span>
                <span class="print-input" style="text-align: right; font-weight: normal !important;">{{ new Intl.NumberFormat().format(item.value1) }}</span>
              </span>
              <span>
                <span class="print-input" style="text-align: right; font-weight: normal !important;">{{ new Intl.NumberFormat().format(item.value2) }}</span>
              </span>
              <span>
                <span class="print-input" style="text-align: right; font-weight: normal !important;">{{ new Intl.NumberFormat().format(item.value3) }}</span>
              </span>
              <span>
                <span class="print-input" style="text-align: right; font-weight: normal !important;">{{ item.value4 }}%</span>
              </span>
            </li>

            <!-- 누계 -->
            <li class="grid-row" style="grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr">
              <span class="header-bg">누계</span>
              <span>
                <span class="print-input" style="text-align: right; font-weight: normal !important;">{{ fieldData[`${selectedFieldId}`] ? new Intl.NumberFormat().format(fieldData[`${selectedFieldId}`].totalB.value1) : 0 }}</span>
              </span>
              <span>
                <span class="print-input" style="text-align: right; font-weight: normal !important;">{{ fieldData[`${selectedFieldId}`] ? new Intl.NumberFormat().format(fieldData[`${selectedFieldId}`].totalB.value2) : 0 }}</span>
              </span>
              <span>
                <span class="print-input" style="text-align: right; font-weight: normal !important;">{{ fieldData[`${selectedFieldId}`] ? new Intl.NumberFormat().format(fieldData[`${selectedFieldId}`].totalB.value3) : 0 }}</span>
              </span>
              <span>
                <span class="print-input" style="text-align: right; font-weight: normal !important;">{{ fieldData[`${selectedFieldId}`] ? fieldData[`${selectedFieldId}`].totalB.value4 : '0.00' }}%</span>
              </span>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>

    <popup-excel-download
      v-model="showExcelDownload"
      :list="getExcelList"
      :title="getExcelFileName"/>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";7
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";


export default {
  components: {
    PopupExcelDownload,
    SearchNavItemSelect,
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
  props: {
    tab: Object,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    projectId() {
      return parseInt(this.$route.params.proj_id) || 0;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    getYearList() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear + 1 - 49;
      const endYear = currentYear + 1;
      const yearList = [];
      for (let i = startYear; i <= endYear; i++) {
        yearList.push({text:`${i}`,  value:i})
      }
      return yearList.reverse();
    },
    getMonthList() {
      const monthList = [];
      for(let i = 0; i < 12; i++) {
        const month = i + 1;
        monthList.push({text: `${month}월`, value: month});
      }
      return monthList;
    },
    getExcelList() {
      const fieldData = this.fieldData[this.selectedFieldId];
      if(!fieldData) return [];

      const list = fieldData.inputB;
      if(!list) return [];

      const result = [];
      for(const row of list) {
        result.push({
          '항목별': row.label,
          '예산': new Intl.NumberFormat().format(row.value1),
          '당월 사용금액': new Intl.NumberFormat().format(row.value2),
          '누계': new Intl.NumberFormat().format(row.value3),
          '집행률(%)': new Intl.NumberFormat().format(row.value4),
        });
      }
      const total = fieldData.totalB;
      result.push({
        '항목별': '누계',
        '예산': new Intl.NumberFormat().format(total.value1),
        '당월 사용금액': new Intl.NumberFormat().format(total.value2),
        '누계': new Intl.NumberFormat().format(total.value3),
        '집행률(%)': new Intl.NumberFormat().format(total.value4),
      });
      return result;
    },
    getExcelFileName() {
      let title = '안전보건 관련 예산(A형)';
      const fieldData = this.fieldData[this.selectedFieldId];
      if(!fieldData) {
        return title;
      }

      title += `_${fieldData.stdInfo.com_name}`;

      if(parseInt(this.selectedFieldId) === 0) {
        title += `_전체사업장`;
      } else {
        title += `_${fieldData.stdInfo.field_name}`;
      }

      title += `_${this.year}년`;
      title += `_${this.month}월`;
      return title;
    },
    getSelectedFieldName() {
      if(parseInt(this.selectedFieldId) === 0) {
        return '전체 사업장';
      }

      const fieldData = this.fieldData[this.selectedFieldId];
      if(!fieldData) {
        return '';
      }

      const stdInfo = fieldData.stdInfo;
      if(stdInfo) {
        return stdInfo.field_name;
      } else {
        return '';
      }
    },
  },
  watch: {
    year: {
      handler() {
        this.loadListBoard();
      }
    },
    month: {
      handler() {
        this.loadListBoard();
      }
    },
    selectedCompanyId: {
      handler() {
        this.loadListBoard();
      }
    },
    selectedFieldId: {
      handler() {
        console.log('selectedFieldId', this.selectedFieldId);
      }
    },
  },
  data () {
    return {
      showExcelDownload: false,
      isPrint: false,
      oldForm: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      companyList: [],
      cachedData: {},
      selectedCompanyId: 0,
      fieldList: [],      // 선택된 업체와 연관된 현장 ID
      selectedFieldId: 0, // 선택된 현장 ID
      selectedForm: [],
      fieldData: {},
      form: {
        total:{},
        stdInfo:{},
        fileList: [],
        totalB: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
        inputB: [
          {label: '방호장치, 안전장치 구입 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '안전보건 관련 물품 및 보호구 등 구입 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '위험설비 자동화 등 안전시설 개선 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '설비 및 시설물에 대한 안전점검 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '안전보건진단, 위탁 및 컨설팅 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '작업환경측정 및 특수건강진단 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '작업환경개선 및 근골격계 질환 예방 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '공상자 치료 및 응급구조 관련 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '건강관리실 및 건강증진실 운영 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '안전보건교육 훈련 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '안전보건관계자 외부교육 및 훈련 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '안전보건 포상 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '안전보건활동 촉진을 위한 캠페인 등 지원 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '안전보건조직 운영 및 재해예방 인력 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '협력업체 지원 비용', value1: 0, value2: 0, value3:0, value4: '0.00'},
          {label: '기타(산업안전보건관리비)', value1: 0, value2: 0, value3:0, value4: '0.00'},
        ],
      }
    }
  },
  created() {
    this.initBreadcrumb();
  },
  mounted () {
    this.loadCompanyList().then();
  },
  methods: {
    initBreadcrumb () {
      this.$store.commit('menu/UPDATE_PAGE_LIST', [{title: 'Home'}, {title: '안전보건 예산'}, {title: '부서별 안전·보건 예산(A형)', active: true}])
    },
    // 조회 부서 옵션을 표시하기 위해 업체 목록을 불러온다
    async loadCompanyList() {
      const page = 1
      const perPage = 1000  // 목록에 전체 리스트를 표시하기 위해, 큰 수로 검색한다
      const projectId = this.projectId
      this.$store.dispatch('company/LOAD_COMPANY_LIST', { page, perPage, projectId }).then((result) => {
        this.companyList.length = 0;
        for(const item of result.data) {
          this.companyList.push(item);
        }

        // 이름순 정렬
        this.companyList.sort(function (a, b) {
          if(a.com_name < b.com_name) {
            return -1;
          } else if(a.com_name > b.com_name) {
            return 1;
          } else {
            return 0;
          }
        });
      })
    },
    async loadListBoard () {
      // 현장 목록 비우기
      this.fieldList.splice(0, this.fieldList.length);
      // Object.keys(this.fieldData).forEach(key => delete this.fieldData[key]);
      Object.keys(this.fieldData).forEach(key => this.$delete(this.fieldData, key));
      this.selectedFieldId = 0;

      // 게시글 불러온다
      const boardId = 106
      const page = 1
      const perPage = 1000
      const dateTarget = 'content$header.full'
      const dateBegin = `${this.year}-${this.month < 10 ? '0' + this.month : this.month}-01`
      const dateEnd = `${this.year}-${this.month < 10 ? '0' + this.month : this.month}-31`
      const companyIds = [this.selectedCompanyId];
      // const keyword = [`content$body.stdInfo.field_id*${this.form.stdInfo.field_id}`];

      let data;

      // 캐싱된 데이터가 있으면, 불러서 쓰고
      // console.log('chache_key', `${this.year}-${this.month}:${this.selectedCompanyId}`);
      if(typeof this.cachedData[`${this.year}-${this.month}:${this.selectedCompanyId}`] !== 'undefined') {
        data = this.cachedData[`${this.year}-${this.month}:${this.selectedCompanyId}`];
      }
      // 없으면 API를 호출한다
      else {
        data = await this.$store.dispatch('board/LOAD_POST_LIST', {
          boardId,
          projectId: this.projectId,
          page,
          perPage,
          companyIds,
          // keyword,
          dateTarget,
          dateBegin,
          dateEnd
        });

        // 캐시에 저장
        this.cachedData[`${this.year}-${this.month}:${this.selectedCompanyId}`] = data;
      }

      if(typeof data === 'undefined' || typeof data.data === 'undefined') {
        return;
      }
      const rows = JSON.parse(JSON.stringify(data.data));

      if (rows.length > 0) {
        const sum = {
          stdInfo: {},
          inputB: [],
          inputC: [],
          totalB: {
            value1: 0,
            value2: 0,
            value3: 0,
            value4: '',
          },
          totalC: {
            value1: 0,
            value2: 0,
            value3: 0,
            value4: '',
          },
        };
        for (const data of rows) {
          const header = this.getHeader(data)
          const content = this.getContent(data)
          data.header = header;
          data.content = content;
          delete data.post_content;

          // 엑셀 다운로드 시, 부서 이름을 가져오기 위함
          sum.stdInfo = content.stdInfo;

          const dataSum = {
            totalB: {
              value1: 0,
              value2: 0,
              value3: 0,
              value4: '',
            },
            totalC: {
              value1: 0,
              value2: 0,
              value3: 0,
              value4: '',
            },
          };

          if (typeof data.content.inputB !== 'undefined' && data.content.inputB.length > 0) {
            for (const b of data.content.inputB) {
              let sumRow = sum.inputB.find((sumItem) => sumItem.label === b.label);

              if(typeof b.value1 === 'string') {
                b.value1 = +b.value1.replace(/,/g, '');
              }
              if(typeof b.value2 === 'string') {
                b.value2 = +b.value2.replace(/,/g, '');
              }
              if(typeof b.value3 === 'string') {
                b.value3 = +b.value3.replace(/,/g, '');
              }
              b.value4 = this.percentage(b.value3, b.value1);

              if (sumRow) {
                sumRow.value1 += +b.value1;
                sumRow.value2 += +b.value2;
                sumRow.value3 += +b.value3;
                sumRow.value4 = this.percentage(sumRow.value3, sumRow.value1);
              } else {
                sumRow = {};
                sumRow.label = b.label;
                sumRow.value1 = +b.value1;
                sumRow.value2 = +b.value2;
                sumRow.value3 = +b.value3;
                sumRow.value4 = this.percentage(sumRow.value3, sumRow.value1);
                sum.inputB.push(sumRow);
              }

              dataSum.totalB.value1 += sumRow.value1;
              dataSum.totalB.value2 += sumRow.value2;
              dataSum.totalB.value3 += sumRow.value3;
              dataSum.totalB.value4 = this.percentage(sum.totalB.value3, sum.totalB.value1);

              sum.totalB.value1 += sumRow.value1;
              sum.totalB.value2 += sumRow.value2;
              sum.totalB.value3 += sumRow.value3;
              sum.totalB.value4 = this.percentage(sum.totalB.value3, sum.totalB.value1);
            }
          }
          if (typeof data.content.inputC !== 'undefined' && data.content.inputC.length > 0) {
            for (const b of data.content.inputC) {
              let sumRow = sum.inputC.find((sumItem) => sumItem.label === b.label);

              if(typeof b.value1 === 'string') {
                b.value1 = +b.value1.replace(/,/g, '');
              }
              if(typeof b.value2 === 'string') {
                b.value2 = +b.value2.replace(/,/g, '');
              }
              if(typeof b.value3 === 'string') {
                b.value3 = +b.value3.replace(/,/g, '');
              }
              b.value4 = this.percentage(b.value3, b.value1);

              if (sumRow) {
                sumRow.value1 += +b.value1;
                sumRow.value2 += +b.value2;
                sumRow.value3 += +b.value3;
                sumRow.value4 = this.percentage(sumRow.value3, sumRow.value1);
              } else {
                sumRow = {};
                sumRow.value1 = +b.value1;
                sumRow.value2 = +b.value2;
                sumRow.value3 = +b.value3;
                sumRow.value4 = this.percentage(sumRow.value3, sumRow.value1);
                sum.inputB.push(sumRow);
              }
              dataSum.totalC.value1 += sumRow.value1;
              dataSum.totalC.value2 += sumRow.value2;
              dataSum.totalC.value3 += sumRow.value3;
              dataSum.totalC.value4 = this.percentage(sum.totalC.value3, sum.totalC.value1);

              sum.totalC.value1 += sumRow.value1;
              sum.totalC.value2 += sumRow.value2;
              sum.totalC.value3 += sumRow.value3;
              sum.totalC.value4 = this.percentage(sum.totalB.value3, sum.totalB.value1);
            }
          }

          data.content.totalB = dataSum.totalB;
          data.content.totalC = dataSum.totalC;
          this.$set(this.fieldData, `${data.content.stdInfo.field_id}`, data.content);
          this.fieldList.push(data.content);
          // this.fieldData[`${data.content.stdInfo.field_id}`] = data.content;
        }
        this.$set(this.fieldData, `0`, sum);
        // this.fieldData[`0`] = sum;

        // console.log("Wow", this.fieldData);
      }
    },
    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; }}");
    },
    print(css) {
      // 프린트
      this.isPrint = true;

      setTimeout(() => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (var i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML
            .trimStart()
            .trimEnd()
            .replace(/\r\n/gi, "<br>")
            .replace(/\\n/gi, "<br>")
            .replace(/\n/gi, "<br>");

          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }

        const hidePrintTitleEl = document.getElementById("hidePrintTitle");
        const hidePrintTitle = hidePrintTitleEl && hidePrintTitleEl.value === "true"

        const g_label = document.getElementById("print-label") ? document.getElementById("print-label").innerHTML : '';
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;

        const beforeApprovalEl = document.getElementById("print-approval");
        const g_oBeforeApproval = beforeApprovalEl ? beforeApprovalEl.innerHTML : '';

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = ''
          if (g_label && isPrint && !hidePrintTitle) {
            document.body.innerHTML += `${g_label}<br>`
          }
          document.body.innerHTML += `${g_oBeforeBody}<br>${g_oBeforeApproval}`;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        window.print();
        location.reload();
      }, 300);
    },
    onClickPrint() {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-vertical.svg" },
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-horizontal.svg" },
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },
    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },
    comma (str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    removeComma (str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(',', '')
        return `${Number(noneComma)}`
      }
      return '0'
    },
    percentage(a, b) {
      // A를 B로 나눈 결과를 구합니다.
      const result = b !== 0 ? (a / b) * 100 : 0;
      // 소수점 2자리까지 반올림합니다.
      const roundedResult = Math.round(result * 100) / 100;
      // 문자열로 변환합니다.
      const resultString = roundedResult.toString();
      // 소수점이 없는 경우 '.00'을 덧붙입니다.
      if (!resultString.includes('.')) {
        return resultString + '.00';
      }
      // 소수점이 하나만 있는 경우 '0'을 덧붙입니다.
      if (resultString.split('.')[1].length === 1) {
        return resultString + '0';
      }
      // 소수점이 둘 이상인 경우 그대로 반환합니다.
      return resultString;
    }
  },
}
</script>

<style scoped>

</style>
